module.exports = "/davinci/assets/a07df7d31695031a368e9c66e4ee3462.svg";